import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { X } from 'lucide-react';

// Use standard publishable key (must be explicitly provided for the frontend)
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_mock_fallback'); 

export default function StripeCheckoutModal({ clientSecret, onClose }) {
  if (!clientSecret) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0, 0, 0, 0.75)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: 'var(--spacing-md)'
    }}>
      <div className="glass" style={{
        width: '100%',
        maxWidth: '600px',
        height: '80vh',
        minHeight: '500px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 'var(--radius-lg)',
        background: '#0f172a',
        overflow: 'hidden',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3)'
      }}>
        
        {/* Fixed Header */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          padding: '1rem 1rem 0', 
          background: '#0f172a',
          borderBottom: '1px solid rgba(255,255,255,0.05)',
          paddingBottom: '1rem',
          zIndex: 10 
        }}>
          <button 
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid var(--surface-border)',
              borderRadius: '50%',
              width: '36px', height: '36px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer',
              color: 'var(--text-main)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
          >
            <X size={20} />
          </button>
        </div>
        
        {/* Scrollable Content */}
        <div style={{ 
          overflowY: 'auto', 
          flex: 1,
          padding: '1rem',
          background: '#0f172a'
        }}>
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>

      </div>
    </div>
  );
}
